// V12 — KLAVIYO TRACKING ADDED
// Adds Custom Plan Started + Custom Plan Completed events
// All window.* functions correctly outside render()
// Based on V11 (Adam's feedback May 18: Overbite → Bundle + Lower, Recessed chin → Lateral + Lower)

document.addEventListener('DOMContentLoaded', function () {
  const TOTAL_STEPS = 6;

  const state = {
    step: 0,
    completedTracked: false,
    startedTracked: false,
    answers: {
      goal: null,
      symptoms: [],
      bite: null,
      narrowPalate: null,
      severity: null
    }
  };

  const symptoms = {
    aesthetics: [
      { id: 'narrow_smile', label: 'Narrow smile', desc: 'Smile looks "corridor" or dark corners when smiling' },
      { id: 'crowded_teeth', label: 'Crowded or overlapping teeth', desc: "Teeth don't fill the full smile" },
      { id: 'recessed_chin', label: 'Weak jawline / Recessed chin', desc: 'Chin looks recessed from the side' },
      { id: 'flat_midface', label: 'Flat cheeks / Sunken midface', desc: 'No cheekbone projection' },
      { id: 'sunken_undereye', label: 'Sunken under-eye area', desc: 'Hollow or dark under-eye appearance' },
      { id: 'flat_profile', label: 'Flat facial profile', desc: 'Face looks "fading" or lacks projection' }
    ],
    health: [
      { id: 'mouth_breathing', label: 'Mouth breathing', desc: 'Breathe through mouth day or night' },
      { id: 'snoring', label: 'Snoring at night', desc: 'Snoring or waking up tired' },
      { id: 'jaw_pain', label: 'Jaw pain or clicking (TMJ)', desc: 'Pain, clicking, or tension in jaw' },
      { id: 'teeth_grinding', label: 'Teeth grinding / Clenching', desc: 'Grinding at night or clenching' },
      { id: 'headaches', label: 'Morning headaches', desc: 'Waking up with headaches' },
      { id: 'stuffy_nose', label: 'Chronically stuffy nose', desc: 'Restricted nasal airflow' }
    ]
  };

  // DYNAMIC PRODUCT DATA from Shopify (injected via Liquid in custom-plan-page.liquid)
  // Falls back to hardcoded data if window.mewingProducts is not available
  const productData = window.mewingProducts || {
    'Lateral Growth Plate': {
      url: '/products/lateral-growth-plate',
      image: 'https://mewingshop.com/cdn/shop/files/0051-2paI4HO6Wlg0tm.jpg?crop=center&height=400&v=1757160470&width=400',
      rating: 4.74,
      reviews: 42
    },
    'Full Growth Plate': {
      url: '/products/full-expansion-plate',
      image: 'https://mewingshop.com/cdn/shop/files/Generated_Image_September_06_2025_-_6_08AM.jpg?crop=center&height=400&v=1761989181&width=400',
      rating: 4.74,
      reviews: 39
    },
    'Lower Growth Plate': {
      url: '/products/lateral-growth-lower-plate',
      image: 'https://mewingshop.com/cdn/shop/files/Generated_Image_September_06_2025_-_6_04AM.jpg?crop=center&height=400&v=1757163906&width=400',
      rating: 4.74,
      reviews: 16
    },
    'Forward Development Bundle': {
      url: '/products/max-forward-development-bundle',
      image: 'https://mewingshop.com/cdn/shop/files/7copy_32f2a5b4-f86b-4796-9dd2-14a3a5cdfc2c.png?crop=center&height=400&v=1762707300&width=400',
      rating: 4.74,
      reviews: 24
    }
  };

  const progressEl = document.getElementById('progress');
  const contentEl = document.getElementById('step-content');

  if (!progressEl || !contentEl) {
    console.error('Custom plan: #progress or #step-content not found.');
    return;
  }

  // ============================================
  // RECOMMENDATION LOGIC
  // Validated by Adam on May 18, 2026
  // ============================================
  function getRecommendation() {
    const s = state.answers.symptoms;
    const bite = state.answers.bite;
    const severity = state.answers.severity;

    const hasJawIssues = s.some(x => ['jaw_pain', 'teeth_grinding', 'headaches'].includes(x));
    const hasNarrowOnly = s.length > 0 && s.every(x => ['narrow_smile', 'crowded_teeth'].includes(x));
    const hasForwardDeficiency = s.some(x => ['flat_midface', 'sunken_undereye', 'flat_profile', 'recessed_chin'].includes(x));
    const hasMouthBreathingOnly = s.length > 0 && s.every(x => ['mouth_breathing', 'snoring', 'stuffy_nose'].includes(x));
    const forwardCount = s.filter(x => ['flat_midface', 'sunken_undereye', 'flat_profile'].includes(x)).length;

    let products = [];
    let reason = '';
    let needsConsult = false;

    // RULE 1: Overbite → Forward Development Bundle + Lower (Adam's feedback May 18)
    if (bite === 'overbite') {
      products = ['Forward Development Bundle', 'Lower Growth Plate'];
      reason = 'An overbite indicates both jaws need attention. The Forward Development Bundle provides comprehensive maxillary advancement, while the Lower Growth Plate prevents bite lock and ensures balanced development.';
    }
    // RULE 2: Underbite → Full Growth Plate
    else if (bite === 'underbite') {
      products = ['Full Growth Plate'];
      reason = 'Your lower jaw sits forward of your upper jaw. The Full Growth Plate supports forward maxillary development to bring balance to your bite.';
    }
    // RULE 3: Jaw issues (TMJ, grinding, headaches) → Full + Lower
    else if (hasJawIssues) {
      products = ['Full Growth Plate', 'Lower Growth Plate'];
      reason = 'Jaw pain, grinding, or headaches indicate a misaligned upper/lower jaw relationship. The Full Growth Plate addresses the upper structure while the Lower Plate prevents TMJ complications.';
    }
    // RULE 4: Narrow only (no forward deficiency) → Lateral
    else if (hasNarrowOnly && !hasForwardDeficiency) {
      products = ['Lateral Growth Plate'];
      reason = 'Your main concern is palate width. The Lateral Growth Plate is the best starting point for narrowness without forward deficiency.';
    }
    // RULE 5: Forward deficiency (severe or 2+ signs) → Bundle
    else if (hasForwardDeficiency && (severity === 'severe' || forwardCount >= 2)) {
      products = ['Forward Development Bundle'];
      reason = 'Multiple forward deficiency indicators suggest a comprehensive approach. The Forward Development Bundle addresses the entire maxillary region including under-eye area and midface projection.';
    }
    // RULE 6: Forward deficiency (moderate) → Full
    else if (hasForwardDeficiency) {
      products = ['Full Growth Plate'];
      reason = "The Full Growth Plate handles both width and controlled forward development. It's the most versatile standalone appliance for your concerns.";
    }
    // RULE 7: Mouth breathing only → Consultation needed
    else if (hasMouthBreathingOnly) {
      needsConsult = true;
      reason = 'Mouth breathing can stem from different structural causes. We recommend a quick consultation to identify the root cause and match you with the right appliance.';
    }
    // RULE 8: Multiple symptoms (4+) → Bundle
    else if (s.length >= 4) {
      products = ['Forward Development Bundle'];
      reason = 'Your structural concerns span multiple areas. The Forward Development Bundle targets the full structure at once — best value for comprehensive development.';
    }
    // RULE 9: Recessed chin alone → Lateral + Lower (Adam's feedback May 18)
    else if (s.includes('recessed_chin')) {
      products = ['Lateral Growth Plate', 'Lower Growth Plate'];
      reason = 'A recessed chin often traces back to both jaws. The Lateral Growth Plate widens the maxilla foundation, while the Lower Plate supports the mandible to project forward.';
    }
    // RULE 10: Default → Lateral
    else {
      products = ['Lateral Growth Plate'];
      reason = 'Based on your profile, the Lateral Growth Plate is an excellent starting point for structural development.';
    }

    return { products, reason, needsConsult };
  }

  // ============================================
  // EDUCATIONAL CONTENT (from V10)
  // Structural profiles with whatWeSee, whatThisMeans, pathForward
  // ============================================
  function getStructuralProfile() {
    const s = state.answers.symptoms;
    const bite = state.answers.bite;
    const severity = state.answers.severity;

    const hasJawIssues = s.some(x => ['jaw_pain', 'teeth_grinding', 'headaches'].includes(x));
    const hasNarrowOnly = s.length > 0 && s.every(x => ['narrow_smile', 'crowded_teeth'].includes(x));
    const hasForwardDeficiency = s.some(x => ['flat_midface', 'sunken_undereye', 'flat_profile', 'recessed_chin'].includes(x));
    const hasMouthBreathingOnly = s.length > 0 && s.every(x => ['mouth_breathing', 'snoring', 'stuffy_nose'].includes(x));
    const forwardCount = s.filter(x => ['flat_midface', 'sunken_undereye', 'flat_profile'].includes(x)).length;

    let whatWeSee = '';
    let whatThisMeans = '';
    let pathForward = '';

    if (bite === 'overbite') {
      whatWeSee = 'Your upper teeth significantly overlap your lower teeth. This deep bite pattern affects how your jaws relate to each other.';
      whatThisMeans = 'An overbite often indicates the upper jaw needs forward development, while the lower jaw may be restricted. This can affect breathing, facial profile, and jaw comfort over time.';
      pathForward = 'Addressing both jaws together works best — forward development of the upper jaw combined with lower jaw support creates balanced bite alignment and improved facial harmony.';
    }
    else if (bite === 'underbite') {
      whatWeSee = 'Your lower jaw sits forward of your upper jaw. This creates a bite where the lower teeth close in front of the upper teeth.';
      whatThisMeans = "This pattern typically indicates that the upper jaw (maxilla) hasn't developed fully forward during growth. When the maxilla is recessed, it can affect midface projection, airway space, and overall facial balance.";
      pathForward = 'The priority is supporting forward development of the upper jaw. With consistent use, the maxilla can remodel and move forward — bringing your bite and facial structure into better alignment.';
    }
    else if (hasJawIssues) {
      whatWeSee = 'You experience jaw pain, clicking, grinding, or morning headaches. These are signs of tension in your jaw joint.';
      whatThisMeans = "When upper and lower jaws don't align properly, the temporomandibular joint (TMJ) absorbs the stress. Grinding and clenching are often the body's attempt to find a comfortable bite position.";
      pathForward = 'Addressing both jaws together — upper expansion plus lower adaptation — relieves pressure on the joint and allows your bite to settle into a more natural position.';
    }
    else if (hasNarrowOnly && !hasForwardDeficiency) {
      whatWeSee = 'Your main concerns are related to palate width: a narrow smile, crowded teeth, or dark corners when you smile.';
      whatThisMeans = "A narrow palate limits tongue space, can crowd your teeth, and often restricts nasal airflow. It's one of the most common structural issues — and one of the most responsive to expansion.";
      pathForward = 'Lateral expansion of the upper jaw creates more tongue space, widens your smile naturally, and supports better breathing. Most people notice changes within the first few weeks.';
    }
    else if (hasForwardDeficiency && (severity === 'severe' || forwardCount >= 2)) {
      whatWeSee = 'Multiple signs point to forward deficiency: flat midface, sunken under-eye area, or a profile that lacks projection.';
      whatThisMeans = "When the upper jaw is recessed, it affects everything connected to it — the cheekbones, the area under your eyes, and your overall facial harmony. This pattern often develops during childhood but can still be addressed in adults.";
      pathForward = 'A comprehensive approach works best here. Both width expansion and forward traction help bring the entire midface forward — improving projection, airway space, and structural balance.';
    }
    else if (hasForwardDeficiency) {
      whatWeSee = 'Your profile suggests some forward deficiency — perhaps a flat midface, recessed chin, or lack of projection from the side.';
      whatThisMeans = 'This typically means the upper jaw could benefit from forward development. Even moderate deficiency can affect breathing, facial aesthetics, and how the lower jaw positions itself.';
      pathForward = 'An appliance that handles both width and forward development gives you flexibility. You can focus on expansion first, then introduce forward movement as your structure adapts.';
    }
    else if (hasMouthBreathingOnly) {
      whatWeSee = 'Your main concerns are related to breathing: mouth breathing, snoring, or a chronically stuffy nose.';
      whatThisMeans = "Breathing issues can stem from different structural causes — narrow palate, deviated septum, or other factors. Without knowing the root cause, it's hard to recommend the right appliance.";
      pathForward = 'We recommend a quick consultation to understand your specific situation. Our team can help identify the structural cause and match you with the right solution.';
    }
    else if (s.length >= 4) {
      whatWeSee = 'Your responses indicate multiple structural concerns across different areas — both aesthetic and functional.';
      whatThisMeans = "When several issues appear together, they're usually connected. A narrow palate, forward deficiency, and breathing issues often share the same root cause: underdeveloped facial structure.";
      pathForward = 'A comprehensive approach addresses the entire structure at once — width, forward development, and airway support. This creates balanced, lasting results rather than treating symptoms one by one.';
    }
    else if (s.includes('recessed_chin')) {
      whatWeSee = 'You notice a weak jawline or recessed chin — your chin appears to "fade" from the side rather than project forward.';
      whatThisMeans = "A recessed chin often traces back to both jaws. When the maxilla is narrow, it doesn't provide the foundation the lower jaw needs to position itself forward.";
      pathForward = 'Addressing both jaws together gives the best results — widening the upper jaw creates structural support, while lower jaw expansion helps the chin project forward naturally.';
    }
    else {
      whatWeSee = 'Based on your responses, you have some structural concerns that could benefit from palate expansion.';
      whatThisMeans = 'The upper jaw (maxilla) is the foundation of facial structure. When it develops fully, it supports better breathing, a wider smile, and improved facial balance.';
      pathForward = 'Starting with lateral expansion addresses the most common structural issues. As your palate widens, you may notice improvements in breathing, tongue posture, and facial aesthetics.';
    }

    return { whatWeSee, whatThisMeans, pathForward };
  }

  function generateStars(rating) {
    const fullStars = Math.floor(rating);
    const hasHalf = rating % 1 >= 0.5;
    const emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);

    const starSVG = `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"></path>
      </svg>
    `;

    let stars = '';
    for (let i = 0; i < fullStars; i++) stars += `<span class="star">${starSVG}</span>`;
    if (hasHalf) stars += `<span class="star half">${starSVG}</span>`;
    for (let i = 0; i < emptyStars; i++) stars += `<span class="star empty">${starSVG}</span>`;
    return stars;
  }

  // AJAX Cart function
  async function addToCart(items, redirectUrl) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }

      const data = await response.json();
      window.location.href = redirectUrl;
      return data;
    } catch (error) {
      console.error('Error adding to cart:', error);
      alert('Sorry, there was an error adding the product to your cart. Please try again.');
    }
  }

  window.handleAddToCart = function (productNames) {
    const items = productNames.map(name => {
      const product = productData[name];
      if (!product || !product.variantId) {
        console.error('Product not found or missing variant ID:', name);
        return null;
      }
      return { id: product.variantId, quantity: 1 };
    }).filter(item => item !== null);

    if (items.length === 0) return;

    let redirectUrl;
    if (productNames.length === 1) {
      redirectUrl = productData[productNames[0]]?.url || '/cart';
    } else {
      redirectUrl = productData[productNames[0]]?.url || '/cart';
    }

    addToCart(items, redirectUrl);
  };

  function generateProductCard(productName, isPrimary) {
    const data = productData[productName];

    if (!data) {
      console.warn('Product not found in productData:', productName);
      return '';
    }

    return `
      <div class="product-card ${isPrimary ? 'primary' : ''}">
        <img src="${data.image}" alt="${productName}">
        <div class="product-info">
          <div class="name">${productName}</div>
          <div class="type">${isPrimary ? 'Recommended for you' : 'Recommended addition'}</div>
          <div class="rating">
            <div class="stars">${generateStars(data.rating)}</div>
            <span class="rating-text">${data.reviews} reviews</span>
          </div>
        </div>
      </div>
    `;
  }

  function renderProgress() {
    progressEl.innerHTML = Array.from({ length: TOTAL_STEPS }, (_, i) => {
      let cls = 'progress-dot';
      if (i === state.step) cls += ' active';
      else if (i < state.step) cls += ' done';
      else cls += ' pending';
      return `<div class="${cls}"></div>`;
    }).join('');
  }

  function renderBackRow() {
    if (state.step <= 0 || state.step >= TOTAL_STEPS - 1) return '';
    return `
      <div class="back-row">
        <button class="back-btn" type="button" onclick="goBack()">← Back</button>
      </div>
    `;
  }

  function renderStepHeader(title, subtitle) {
    return `
      <h2 class="step-title">${title}</h2>
      <p class="step-subtitle">${subtitle}</p>
    `;
  }

  function renderGoalStep() {
    contentEl.innerHTML = `
      <div class="step step-goal">
        ${renderStepHeader("What's your main goal?", "This helps us understand your priorities")}
        <div class="options-list">
          <button type="button" class="option-btn ${state.answers.goal === 'aesthetics' ? 'selected' : ''}" onclick="selectGoal('aesthetics')">
            <span class="emoji">✨</span>
            <div class="text-wrap">
              <div class="label">Facial aesthetics</div>
              <div class="desc">Improve facial structure and appearance</div>
            </div>
          </button>
          <button type="button" class="option-btn ${state.answers.goal === 'health' ? 'selected' : ''}" onclick="selectGoal('health')">
            <span class="emoji">💨</span>
            <div class="text-wrap">
              <div class="label">Health & breathing</div>
              <div class="desc">Better airway, sleep, and function</div>
            </div>
          </button>
          <button type="button" class="option-btn ${state.answers.goal === 'both' ? 'selected' : ''}" onclick="selectGoal('both')">
            <span class="emoji">🎯</span>
            <div class="text-wrap">
              <div class="label">Both equally</div>
              <div class="desc">Comprehensive structural improvement</div>
            </div>
          </button>
        </div>
      </div>
    `;
  }

  function renderSymptomsStep() {
    const list = state.answers.goal === 'aesthetics'
      ? symptoms.aesthetics
      : state.answers.goal === 'health'
        ? symptoms.health
        : [...symptoms.aesthetics, ...symptoms.health];

    contentEl.innerHTML = `
      <div class="step step-symptoms">
        ${renderBackRow()}
        ${renderStepHeader('Which of these sound like you?', 'Select all that apply')}
        <div class="symptom-grid">
          ${list.map(item => {
            const selected = state.answers.symptoms.includes(item.id);
            return `
              <button type="button" class="symptom-btn ${selected ? 'selected' : ''}" onclick="toggleSymptom('${item.id}')">
                <div class="text-wrap">
                  <div class="label">${item.label}</div>
                  <div class="desc">${item.desc}</div>
                </div>
              </button>
            `;
          }).join('')}
        </div>
        <button type="button" class="continue-btn" onclick="nextStep()" ${state.answers.symptoms.length === 0 ? 'disabled' : ''}>
          Continue →
        </button>
      </div>
    `;
  }

  function renderBiteStep() {
    contentEl.innerHTML = `
      <div class="step step-bite">
        ${renderBackRow()}
        ${renderStepHeader('How does your bite align?', 'When you close your mouth naturally')}
        <div class="info-box">
          <p><strong>Overbite:</strong> Upper teeth significantly cover lower<br><strong>Underbite:</strong> Lower jaw/teeth sit in front of upper</p>
        </div>
        <div class="bite-options">
          <button type="button" class="bite-btn ${state.answers.bite === 'overbite' ? 'selected' : ''}" onclick="selectBite('overbite')">
            <div class="text-wrap"><div class="label">Overbite</div><div class="desc">Upper covers lower</div></div>
          </button>
          <button type="button" class="bite-btn ${state.answers.bite === 'underbite' ? 'selected' : ''}" onclick="selectBite('underbite')">
            <div class="text-wrap"><div class="label">Underbite</div><div class="desc">Lower in front of upper</div></div>
          </button>
          <button type="button" class="bite-btn ${state.answers.bite === 'normal' ? 'selected' : ''}" onclick="selectBite('normal')">
            <div class="text-wrap"><div class="label">Normal</div><div class="desc">Teeth meet evenly</div></div>
          </button>
          <button type="button" class="bite-btn ${state.answers.bite === 'not_sure' ? 'selected' : ''}" onclick="selectBite('not_sure')">
            <div class="text-wrap"><div class="label">Not sure</div><div class="desc">Skip this</div></div>
          </button>
        </div>
      </div>
    `;
  }

  function renderPalateStep() {
    contentEl.innerHTML = `
      <div class="step step-palate">
        ${renderBackRow()}
        ${renderStepHeader('Quick palate width check', 'When you smile wide, can you see your last molars?')}
        <div class="info-box">
          <p>💡 If you can't see your back teeth when smiling, it often indicates a narrow palate that would benefit from expansion.</p>
        </div>
        <div class="bite-options">
          <button type="button" class="bite-btn ${state.answers.narrowPalate === true ? 'selected' : ''}" onclick="selectNarrowPalate(true)">
            <div class="text-wrap"><div class="label">No, I can't see them</div><div class="desc">Narrow palate likely</div></div>
          </button>
          <button type="button" class="bite-btn ${state.answers.narrowPalate === false ? 'selected' : ''}" onclick="selectNarrowPalate(false)">
            <div class="text-wrap"><div class="label">Yes, I can see them</div><div class="desc">Adequate width</div></div>
          </button>
          <button type="button" class="bite-btn ${state.answers.narrowPalate === 'not_sure' ? 'selected' : ''}" onclick="selectNarrowPalate('not_sure')">
            <div class="text-wrap"><div class="label">Not sure</div><div class="desc">Skip this</div></div>
          </button>
        </div>
      </div>
    `;
  }

  function renderSeverityStep() {
    contentEl.innerHTML = `
      <div class="step step-severity">
        ${renderBackRow()}
        ${renderStepHeader('How severe would you say?', 'This calibrates the right intervention level')}
        <div class="options-list">
          <button type="button" class="option-btn ${state.answers.severity === 'slight' ? 'selected' : ''}" onclick="selectSeverity('slight')">
            <div class="text-wrap"><div class="label">Slight</div><div class="desc">Noticeable to me, subtle to others</div></div>
          </button>
          <button type="button" class="option-btn ${state.answers.severity === 'moderate' ? 'selected' : ''}" onclick="selectSeverity('moderate')">
            <div class="text-wrap"><div class="label">Moderate</div><div class="desc">Clearly visible, affects my confidence</div></div>
          </button>
          <button type="button" class="option-btn ${state.answers.severity === 'severe' ? 'selected' : ''}" onclick="selectSeverity('severe')">
            <div class="text-wrap"><div class="label">Significant</div><div class="desc">Major concern, impacts daily life</div></div>
          </button>
        </div>
      </div>
    `;
  }

  function renderConsultResult(reason, profile) {
    contentEl.innerHTML = `
      <div class="step step-result result-consult result-combined">
        <div class="result-header">
          <div class="result-icon">🤔</div>
          <h2 class="step-title">We'd like to learn more</h2>
        </div>
        <div class="profile-section">
          <div class="profile-box">
            <strong>What we see</strong>
            <p>${profile.whatWeSee}</p>
          </div>
          <div class="profile-box">
            <strong>What this means</strong>
            <p>${profile.whatThisMeans}</p>
          </div>
          <div class="profile-box highlight">
            <strong>Path forward</strong>
            <p>${profile.pathForward}</p>
          </div>
        </div>
        <div class="action-buttons">
          <a href="mailto:contact@mewingshop.com?subject=Product Recommendation Request" class="contact-btn">Contact Support →</a>
        </div>
        <button type="button" class="restart-btn" onclick="restart()">Start over</button>
      </div>
    `;
  }

  function renderProductResult(rec, profile) {
    const productsHTML = rec.products.map((productName, index) => generateProductCard(productName, index === 0)).join('');
    const isSingleProduct = rec.products.length === 1;
    const reasonTitle = isSingleProduct ? 'Why this recommendation?' : 'Why this combination?';

    let buttonsHTML = '';
    if (isSingleProduct) {
      buttonsHTML = `
        <div class="action-buttons">
          <button type="button" class="btn-primary" onclick="handleAddToCart(['${rec.products[0]}'])">Add to Cart</button>
        </div>
      `;
    } else {
      const productNamesJSON = JSON.stringify(rec.products).replace(/"/g, '&quot;');
      const primaryProductJSON = JSON.stringify([rec.products[0]]).replace(/"/g, '&quot;');
      buttonsHTML = `
        <div class="action-buttons">
          <button type="button" class="btn-primary" onclick='handleAddToCart(${productNamesJSON})'>Add Both to Cart</button>
          <button type="button" class="btn-secondary" onclick='handleAddToCart(${primaryProductJSON})'>Add ${rec.products[0]} Only</button>
        </div>
      `;
    }

    contentEl.innerHTML = `
      <div class="step step-result result-product result-combined">
        <div class="result-header">
          <div class="result-icon">🎯</div>
          <h2 class="step-title">Your Personalized Plan</h2>
        </div>
        <div class="profile-section">
          <div class="profile-box">
            <strong>What we see</strong>
            <p>${profile.whatWeSee}</p>
          </div>
          <div class="profile-box">
            <strong>What this means</strong>
            <p>${profile.whatThisMeans}</p>
          </div>
          <div class="profile-box highlight">
            <strong>Path forward</strong>
            <p>${profile.pathForward}</p>
          </div>
        </div>
        <div class="section-divider"></div>
        <div class="recommendation-section">
          <div class="section-label">Your Recommendation</div>
          <div class="result-card">
            ${productsHTML}
          </div>
          <div class="reason-box">
            <strong>${reasonTitle}</strong>
            <p>${rec.reason}</p>
          </div>
          ${buttonsHTML}
        </div>
        <button type="button" class="restart-btn" onclick="restart()">Start over</button>
      </div>
    `;
  }

  // ============================================
  // RENDER — main dispatch function
  // ============================================
  function render() {
    renderProgress();
  if (window.klaviyo && !state.startedTracked && state.step >= 1 && state.answers.goal) {
    state.startedTracked = true;
    klaviyo.push(['track', 'Custom Plan Started', {
      custom_plan_goal: state.answers.goal
    }]);
  }
    if (state.step === 0) { renderGoalStep(); return; }
    if (state.step === 1) { renderSymptomsStep(); return; }
    if (state.step === 2) { renderBiteStep(); return; }
    if (state.step === 3) { renderPalateStep(); return; }
    if (state.step === 4) { renderSeverityStep(); return; }

    if (state.step === 5) {
      const rec = getRecommendation();
      const profile = getStructuralProfile();

      // KLAVIYO — Custom Plan Completed (fires once only)
      if (window.klaviyo && !state.completedTracked) {
        state.completedTracked = true;
        const properties = {
          custom_plan_goal:                     state.answers.goal,
          custom_plan_symptoms:                 state.answers.symptoms,
          custom_plan_bite:                     state.answers.bite,
          custom_plan_narrow_palate:            state.answers.narrowPalate,
          custom_plan_severity:                 state.answers.severity,
          custom_plan_recommendation_primary:   rec.products[0] || null,
          custom_plan_recommendation_secondary: rec.products[1] || null,
          custom_plan_needs_consult:            rec.needsConsult
        };
        klaviyo.push(['track', 'Custom Plan Completed', properties]);
        klaviyo.push(['identify', properties]);
      }

      if (rec.needsConsult) {
        renderConsultResult(rec.reason, profile);
      } else {
        renderProductResult(rec, profile);
      }
    }
  } // ← end of render()

  // ============================================
  // EVENT HANDLERS — all outside render()
  // ============================================

  window.selectGoal = function (goal) {
  state.answers.goal = goal;
  state.step = 1;
  render();
};

  window.toggleSymptom = function (id) {
    const idx = state.answers.symptoms.indexOf(id);
    if (idx >= 0) {
      state.answers.symptoms.splice(idx, 1);
    } else {
      state.answers.symptoms.push(id);
    }
    render();
  };

  window.nextStep = function () {
    state.step += 1;
    render();
  };

  window.selectBite = function (value) {
    state.answers.bite = value;
    state.step = 3;
    render();
  };

  window.selectNarrowPalate = function (value) {
    state.answers.narrowPalate = value;
    state.step = 4;
    render();
  };

  window.selectSeverity = function (value) {
    state.answers.severity = value;
    state.step = 5;
    render();
  };

  window.goBack = function () {
    state.step = Math.max(0, state.step - 1);
    render();
  };

  window.restart = function () {
    state.step = 0;
    state.completedTracked = false;
    state.answers = {
      goal: null,
      symptoms: [],
      bite: null,
      narrowPalate: null,
      severity: null
    };
    render();
  };

  // ============================================
  // URL PARAMETERS — pre-fill from email links
  // ============================================
  function checkURLParameters() {
    const urlParams = new URLSearchParams(window.location.search);

    const goalParam = urlParams.get('goal');
    if (goalParam) {
      const validGoals = ['aesthetics', 'health', 'both'];
      if (validGoals.includes(goalParam)) {
        state.answers.goal = goalParam;
        state.step = 1;
        console.log('Goal pre-filled from URL:', goalParam);
      }
    }

    const biteParam = urlParams.get('bite');
    if (biteParam) {
      const validBites = ['underbite', 'overbite', 'normal'];
      if (validBites.includes(biteParam)) {
        state.answers.bite = biteParam;
        if (state.step < 2) state.step = 2;
        console.log('Bite pre-filled from URL:', biteParam);
      }
    }
  }

  // Initialize
  checkURLParameters();
  render();

}); // ← end of DOMContentLoaded